import React, { useEffect, useState, useRef } from "react";
import { Card, CardBody } from "reactstrap";
import { createChart, CrosshairMode } from 'lightweight-charts';
import { getDayHistoryChart } from 'services/api';

const TradingView = (props) => {    
let chartEL, chart;

useEffect(() => {
  preparingTradingviewChart()
}, [])

const preparingTradingviewChart = () => {
  chartEL = document.getElementById("trading-view-box")
  if(chartEL && chartEL.childElementCount === 0 ) {
  chart = createChart(chartEL, {
    width: 800,
    height: 380,
    crosshair: {
      mode: CrosshairMode.Normal,
    },
  });
  getDayHistoryChart(props.symbol.toUpperCase()).then((chartData, index) => {
    let tempData = [];
    chartData.length && chartData.forEach(({ time, l, h, o, c }) => {
      const [getFullYear] = time.split('T')
      tempData.unshift({time: getFullYear, open: o, high: h, low: l, close: c})
    })
  
    goBuildChart(tempData)
  })
}
}

const goBuildChart = (chartData) => {
let candleSeries = chart.addCandlestickSeries();
  candleSeries.setData(chartData);
}

const getDayHistoryChartFunc = () => {
  getDayHistoryChart(props.symbol.toUpperCase()).then((chartData, index) => {
  let tempData = [];
  chartData.length && chartData.forEach(({ time, l, h, o, c }) => {
    const [getFullYear] = time.split('T')
    tempData.unshift({time: getFullYear, open: o, high: h, low: l, close: c})
  })

  goBuildChart(tempData)
})
}

return (
  <Card className=" shadow border-radius-1 trading-item-height">
    <CardBody className="px-0" dir="ltr">
      <div id="trading-view-box">
      </div>
    </CardBody> 
  </Card>
)
}

export default TradingView;